import React, { useState } from "react";
import "./JobsList.css";
import "./CareerPageContent.css";
import { Link, Links } from "react-router-dom";

const jobsData = [
    {
        location: "U.K.",
        title: "BDM – International",
        description: "Having an experience of 5+ years in Sales & Marketing with exposure to International Business and Market.",
        link: "/job/bdm-international"
    },
    {
        location: "U.A.E.",
        title: "DGM – International Business – UAE",
        description: "Having 10 + Years of experience in B2B Channel Sales specialised in Window Blinds Industry.",
        link: "/job/dgm-international-business"
    },
    {
        location: "U.K.",
        title: "BDM – UK",
        description: "Having an experience of 5+ years in Sales & Marketing with exposure to International Business and Market.\nLocation: UK",
        link: "/job/bdm"
    },
    {
        location: "India",
        title: "Business Development Executive",
        description: "Having an experience of 3+ years in Sales & Marketing with exposure to International Business and Market\nLocation: India",
        link: "/job/sales-manager"
    },
    {
        location: "U.A.E.",
        title: "DGM – Sales/Marketing & Operations",
        description: "7 + years experience in Sales – Marketing & Operations with exposure to International Market.\nLocation: UAE",
        link: "/job/hr-manager"
    }
];

const JobsList = () => {
    const [selectedLocation, setSelectedLocation] = useState("Location");

    const handleLocationChange = (e) => {
        setSelectedLocation(e.target.value);
    };

    const filteredJobs =
        selectedLocation === "Location"
            ? jobsData
            : jobsData.filter((job) => job.location === selectedLocation);

    const locations = ["Location", "India", "U.K.", "U.A.E."];

    return (
        <>
            <div className="career-hero-img">
                <img className="hero-img" src="/Assets/CareerPageImages/opportunity.webp" />
            </div>
            <div className="job-list-container">
                <h2 className="job-list-heading">Career Opportunities</h2>
                <div className="job-list-filter-bar">
                    <select
                        className="job-list-location-select"
                        value={selectedLocation}
                        onChange={handleLocationChange}
                    >
                        {locations.map((loc) => (
                            <option key={loc} value={loc}>
                                {loc}
                            </option>
                        ))}
                    </select>
                    <button
                        className="job-list-clear-button"
                        onClick={() => setSelectedLocation("Location")}
                    >
                        CLEAR ALL FILTERS
                    </button>
                </div>

                <div className="job-list-list">
                    {filteredJobs.map((job, index) => (
                        <Link className="job-list-card-link" to={job.link} key={index}>
                            <div className="job-list-card">
                                <div className="job-list-location-box">{job.location}</div>
                                <div className="job-list-details">
                                    <h3 className="job-list-title">{job.title}</h3>
                                    <p className="job-list-description">
                                        {job.description.split("\n").map((line, i) => (
                                            <span key={i}>
                                                {line}
                                                <br />
                                            </span>
                                        ))}
                                    </p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
};

export default JobsList;
